<ng-container>
  <label class="vtz-text"
    [ngClass]="{
        'vtz-form__radio-container-oval-left': !ovalOnRight,
        'vtz-form__radio-container': ovalOnRight,
        'vtz-form__radio-container--nonSelectable': choice().nonSelectable,
        'vtz-form__radio-container--selected': choice().selected,
        'focused': hasFocus
    }">

    @if (!isStringEmpty(choice().choiceDetails?.imageUrl)) {
      @if (isImage(choice().choiceDetails?.imageUrl)) {
        <img class="choice-image" src="{{choice().choiceDetails?.imageUrl}}" [alt]="choice().description">  
      }@else {
        <img class="choice-image" src="assets/images/logo.svg" [alt]="choice().description">
        }  
    }

    @if (!ovalOnRight) {
      <input #checkboxInput type="checkbox"  id="checkboxInputLeft"
        [ngClass]="{'round-checkbox': !choice().nonSelectable, 'no-round-checkbox': choice().nonSelectable}"
        (change)="handleCheckboxChange()"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [checked]="choice().selected" />
      }
      <span class="choice-description">
        {{ choice().description }}
        @if (!isStringEmpty(choice().choiceDetails?.webUrl)) {
          <a mat-icon-button 
          matTooltip="{{tooltipText}}"
          matTooltipPosition="above"
          href="{{choice().choiceDetails?.webUrl}}" target="_blank">
            <mat-icon style="color: #365a8a !important;">info</mat-icon>
          </a>
        }
      </span>
      

      @if (ovalOnRight) {
        <input #checkboxInput  type="checkbox" id="checkboxInputRight"
          [ngClass]="{'round-checkbox': !choice().nonSelectable, 'no-round-checkbox': choice().nonSelectable}"
          (change)="handleCheckboxChange()"
          (focus)="onFocus()"
          (blur)="onBlur()"
          [checked]="choice().selected" />
          <span class="vtz-form__radio-checkmark"></span>
        }
      </label>
    </ng-container>

